import { Pipe, PipeTransform } from '@angular/core';
import { ITranslation } from '@routes/templates/models/template-model';

@Pipe({
    name: 'translationsIndex'
})
export class TranslationsIndexPipe implements PipeTransform {
    transform(contents: ITranslation[], language: string): number {
        return contents?.findIndex(x => x.languageId === language);
    }
}
